import React from 'react'
import ReactDOM from 'react-dom'

import './index.scss'
import App from './react/App'

ReactDOM.render(<App />, document.getElementById('root'))
